import React from 'react';
import PropTypes from 'prop-types';

const Aadhaar = ({ fill, theme, ...props }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 17.4167V10.0833M8.25 16.5V10.0833C8.25 9.16667 8.8 7.33333 11 7.33333C13.2 7.33333 13.75 9.16667 13.75 10.0833V15.5833M5.5 12.8333V10.0833C5.5 8.25 6.6 4.58333 11 4.58333C15.4 4.58333 16.5 8.25 16.5 10.0833M16.5 13.75V12.8333M5.50092 15.5833H5.5M6.41667 2.75H4.58333C4.0971 2.75 3.63079 2.94315 3.28697 3.28697C2.94315 3.63079 2.75 4.0971 2.75 4.58333V6.41667M2.75 15.5833V17.4167C2.75 17.9029 2.94315 18.3692 3.28697 18.713C3.63079 19.0568 4.0971 19.25 4.58333 19.25H6.41667M15.5833 19.25H17.4167C17.9029 19.25 18.3692 19.0568 18.713 18.713C19.0568 18.3692 19.25 17.9029 19.25 17.4167V15.5833M19.25 6.41667V4.58333C19.25 4.0971 19.0568 3.63079 18.713 3.28697C18.3692 2.94315 17.9029 2.75 17.4167 2.75H15.5833"
      stroke="#6B6C7B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Aadhaar.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Aadhaar;
